import type { FastifyInstance } from 'fastify'
import type { Firestore } from 'firebase-admin/firestore'
import { routeOptimizationRoutes } from './routeOptimization.routes.js'
import { authMiddleware } from '../../middleware/auth.middleware.js'
import { PlannerRepository } from '../planner/planner.repository.js'
import { RouteOptimizationController } from './routeOptimization.controller.js'

export async function routeOptimizationModule(fastify: FastifyInstance, firestore: Firestore): Promise<void> {
  // Protect all routes with auth
  fastify.addHook('preHandler', authMiddleware)

  // Initialize dependencies
  const plannerRepository = new PlannerRepository(firestore)
  const controller = new RouteOptimizationController(plannerRepository)

  // Register routes
  await routeOptimizationRoutes(fastify, controller)
}
